class BdShowMoreShowLess {
    constructor(name = 'defaultName', autoInit = true) {
        this.name = name
        this.defaultCollapsedHeight = 250
        this.interval = 1000
        this.completedIntervalLoops = 0
        this.allowedIntervalLoops = 10
        this.addedHeight = 102
        this.containers = new Array
        this.containerClass = 'oxg-show-more-less'
        this.buttonClass = 'show-more-less-button'
        this.expandedHeight = 0
        this.collapsedHeight = 0
        if(autoInit) this.init()
    }
    init() {
        let elements = document.getElementsByClassName(this.containerClass)
        if (!elements) return
        Array.from(elements).forEach((container) => {
            container.style.overflow = 'hidden'
            //button
            let button = container.querySelector('.' + this.buttonClass)
            if ( button ) {
                button.addEventListener('click', (e) => {
                    e.preventDefault()
                    this.expandCollapse(container)
                })
            } else {
                console.error("An expandable container is missing a button to expand or collapse it")
            }

            //set collapsed height value
            this.setCollapsedHeight(container)

            //set is expanded value
            let isExpanded = container.hasAttribute('data-is-expanded') ? container.getAttribute('data-is-expanded') : false
            isExpanded = isExpanded == 'true' ? true : false
            container.setAttribute('data-is-expanded', isExpanded)
            this.updateButton(button, isExpanded)

            //set expanded height value
            this.setExpandedHeight(container)

            let expandable = container.querySelector('.expandable')
            if ( container.getAttribute('data-is-expanded') == 'true' ) {
                expandable.style.height = container.getAttribute('data-expanded-height') + 'px'
                expandable.setAttribute('aria-expanded', 'true')
            } else {
                expandable.style.height = container.getAttribute('data-collapsed-height') + 'px'
                expandable.setAttribute('aria-expanded', 'false')
            }

            expandable.addEventListener('focusin', (e)=> {
                let isExpanded = container.getAttribute('data-is-expanded')
                isExpanded = isExpanded == 'true' ? true : false
                if(isExpanded) {
                    container.setAttribute('data-was-expanded-before-focus', true)
                } else {
                    container.setAttribute('data-was-expanded-before-focus', false)
                    this.expand(container, false)
                }
            })

            expandable.addEventListener('focusout', (e)=> {
                let wasExpandedBeforeFocus = container.getAttribute('data-was-expanded-before-focus')
                wasExpandedBeforeFocus = wasExpandedBeforeFocus == 'true' ? true : false
                if(!wasExpandedBeforeFocus) {
                    this.collapse(container)
                }
            })

            //populate array
            this.containers.push(container)
        })
        this.updateExpandedHeightRegularly()
    }
    expandCollapse(container) {
        if (container.getAttribute('data-is-expanded') == 'true') {
            this.collapse(container)
        } else {
            this.expand(container)
        }
    }
    updateButton(button, isExpanded) {
        if(!button) return
        let buttonTextContainer = button.querySelector('.text')
        let buttonIcon = button.querySelector('.show-more-less-icon')
        let buttonTextElement = buttonTextContainer ? buttonTextContainer : button
        let showMoreText = button.hasAttribute('data-show-more-text') ? button.getAttribute('data-show-more-text') : 'Show more';
        let showLessText = button.hasAttribute('data-show-less-text') ? button.getAttribute('data-show-less-text') : 'Show less';
        if(isExpanded) {
            if(buttonIcon) {
                buttonIcon.style.transition = 'all 0.15s ease'
                buttonIcon.style.transform = 'rotate(180deg)'
                buttonIcon.style.display = 'inline-block'
            }
            buttonTextElement.innerText = showLessText 
            button.setAttribute('aria-label', showLessText)
        } else {
            if(buttonIcon) {
                buttonIcon.style.transition = 'all 0.15s ease'
                buttonIcon.style.transform = 'rotate(0deg)'
                buttonIcon.style.display = 'inline-block'
            }
            buttonTextElement.innerText = showMoreText 
            button.setAttribute('aria-label', showMoreText)
        }
    }
    updateContainerHeight(container) {
        if (container.getAttribute('data-is-expanded') == 'true') {
            this.expand(container)
        } else {
            this.collapse(container)
        }
    }
    collapse(container, updateWasExpanded = true) {
        let expandable = container.querySelector('.expandable')
        let button = container.querySelector('.' + this.buttonClass)
        updateWasExpanded ? container.setAttribute('data-was-expanded-before-focus', false) : null
        this.updateButton(button, false)
        expandable.setAttribute('aria-expanded', 'false')
        container.setAttribute('data-is-expanded', 'false')
        expandable.style.height = container.getAttribute('data-collapsed-height') + 'px'
    }
    expand(container, updateWasExpanded = true) {
        let expandable = container.querySelector('.expandable')
        let button = container.querySelector('.' + this.buttonClass)
        updateWasExpanded ? container.setAttribute('data-was-expanded-before-focus', true) : null
        this.updateButton(button, true)
        expandable.setAttribute('aria-expanded', 'true')
        container.setAttribute('data-is-expanded', 'true')
        expandable.style.height = container.getAttribute('data-expanded-height') + 'px'
    }
    resize() {
        Array.from(this.containers).forEach((container) => {
            let expandedHeight = this.getExpandedHeight(container)
            container.setAttribute('data-expanded-height', expandedHeight)
            this.updateContainerHeight(container)
        })
    }
    getExpandedHeight(container) {
        let expandableInnerWrap = container.querySelector('.expandable-inner-wrap')
        return expandableInnerWrap.clientHeight
    }
    setExpandedHeight(container) {
        let expandable = container.querySelector('.expandable')
        let expandedHeight = this.getExpandedHeight(expandable)
        container.setAttribute('data-expanded-height', expandedHeight)
    }
    getCollapsedHeight(container) {
        let collpasedHeight = container.hasAttribute('data-collapsed-height') ? parseInt(container.getAttribute('data-collapsed-height')) : this.defaultCollapsedHeight
        return collpasedHeight
    }
    setCollapsedHeight(container) {
        let expandedHeight = this.getExpandedHeight(container)
        let collapsedHeight = this.getCollapsedHeight(container)
        if(expandedHeight < collapsedHeight) {
            container.setAttribute('data-collapsed-height', expandedHeight)
        } else {
            container.setAttribute('data-collapsed-height', collapsedHeight)
        }
    }
    updateExpandedHeightRegularly() {
        let interval = this.interval
        let update = null

        const updateRoutine = () => {
            Array.from(this.containers).forEach((container) => {
                let expandedHeight = this.getExpandedHeight(container)
                container.setAttribute('data-expanded-height', expandedHeight)
            })
            this.completedIntervalLoops++
            if ( this.completedIntervalLoops == this.allowedIntervalLoops ) {
                clearInterval(update)
            }
        }
        if( this.completedIntervalLoops == 0 ) {
            update = setInterval(updateRoutine, interval)
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {

    let bdShowMoreShowLess = new BdShowMoreShowLess('bdShowMoreShowLess');
    const bdShowMoreShowLessResize = () => { bdShowMoreShowLess.resize() }

    window.addEventListener('resize', () => {
        window.requestAnimationFrame(bdShowMoreShowLessResize);
    });
    
})